'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _VisibilityLocationSelector = require('./components/VisibilityLocationSelector.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_VisibilityLocationSelector).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/visibility-location-selector/index.js
// module id = 1353
// module chunks = 0